export function getOrderKey(row) {
    return row?.code || row?.id;
}

export function getHeaderRightWidth(screenWidth, layoutSizes, gapWidth = 12) {
    const leftRatio = Number(layoutSizes?.[0]) || 0;
    const rightRatio = Number(layoutSizes?.[1]) || 0;
    const totalRatio = leftRatio + rightRatio;
    if (totalRatio <= 0) return 0;

    return Math.floor((Math.max(0, Number(screenWidth) - gapWidth) * rightRatio) / totalRatio);
}

export function getAvailableTabsWidth(rightPanelWidth, headerRightWidth, existingRightMargin = 20) {
    const panelWidth = Number(rightPanelWidth);
    const measuredHeaderWidth = Number(headerRightWidth);
    const effectiveHeaderWidth = Number.isFinite(measuredHeaderWidth)
        ? Math.min(panelWidth, measuredHeaderWidth)
        : panelWidth;
    return Math.max(0, effectiveHeaderWidth - existingRightMargin);
}

export function limitOrdersKeepingActive(rows, activeOrder, limit) {
    if (!(rows instanceof Array) || rows.length <= limit) return rows || [];

    const activeKey = getOrderKey(activeOrder);
    const activeIndex = activeKey ? rows.findIndex((row) => getOrderKey(row) === activeKey) : -1;
    if (activeIndex < 0 || activeIndex < limit) return rows.slice(0, limit);

    return [...rows.slice(0, Math.max(0, limit - 1)), rows[activeIndex]];
}

export function fitOrdersToWidth({ orders, activeKey, availableWidth, reservedWidth = 0, gapWidth = 0, getItemWidth }) {
    const includedKeys = new Set();
    let usedWidth = reservedWidth;
    const activeOrder = activeKey ? orders.find((item) => getOrderKey(item) === activeKey) : null;

    const tryInclude = (item, force = false) => {
        const key = getOrderKey(item);
        if (!key || includedKeys.has(key)) return;

        const itemWidth = getItemWidth(item, key === activeKey);
        const nextGapWidth = usedWidth > 0 ? gapWidth : 0;
        if (!force && usedWidth + nextGapWidth + itemWidth > availableWidth) return;

        includedKeys.add(key);
        usedWidth += nextGapWidth + itemWidth;
    };

    // Keep the voucher currently shown even when newer orders already occupy
    // the available width. The returned order remains the source-list order.
    if (activeOrder) tryInclude(activeOrder, true);
    orders.forEach((item) => tryInclude(item));

    return orders.filter((item) => includedKeys.has(getOrderKey(item)));
}
